/* eslint-disable */

export enum NavigationType {
	Item = 0,
	Sliding = 1,
	Tree = 2,
	
}
